import { takeLatest, fork, put, all, call } from 'redux-saga/effects'

import i18n from 'i18n'
import { immigrateCategoriesAPI } from 'features/immigrate-category/api'
import { immigrateCategoryEntriesList } from './slice'
import { RequestUtils } from 'utils'

function* getList({ payload: { params } }) {
  try {
    const requestParams = RequestUtils.getMapRequestParams(params)

    const response = yield call(immigrateCategoriesAPI.getQuestions, requestParams)

    const { data } = response

    const meta = data?.meta

    const { current_page, last_page } = meta ?? {}

    if (current_page && last_page && current_page > last_page) {
      yield put(
        immigrateCategoryEntriesList.getList({
          params: {
            ...params,
            page: last_page,
          },
        })
      )
    } else {
      yield put(immigrateCategoryEntriesList.getListSuccess(data))
    }
  } catch (error) {
    const message = error.response?.data?.message || i18n.t('error')
    yield put(immigrateCategoryEntriesList.getListError(message))
  }
}

function* watchGetList() {
  yield takeLatest(immigrateCategoryEntriesList.getList, getList)
}

export function* listSaga() {
  yield all([fork(watchGetList)])
}
